export const experience = [
  {
    date: 'Jul 2025 — Sep 2025',
    title: 'Middle Frontend Engineer',
    organization: 'Forte Bank · Hybrid · Astana, Kazakhstan',
    points: [
      'Set up CI/CD pipelines and optimized library usage to improve build speed and code quality.',
      'Integrated REST APIs with internal banking systems while following security and performance requirements.',
      'Configured NGINX, containerized services with Docker, optimized SEO, and tested web applications.'
    ]
  },
  {
    date: 'Apr 2025 — Jun 2025',
    title: 'Junior Frontend Engineer',
    organization: 'Forte Bank · On-site · Astana, Kazakhstan',
    points: [
      'Contributed to internal banking applications using React, JavaScript, and TypeScript.',
      'Implemented responsive interfaces and interactive UI components based on Figma prototypes.',
      'Collaborated with development teams to improve usability and maintain frontend consistency.'
    ]
  },
  {
    date: 'Sep 2022 — Present',
    title: 'Frontend Engineer',
    organization: 'Freelance · Astana, Kazakhstan',
    points: [
      'Developed and refined React and Vue applications for small businesses and startup-style products.',
      'Worked closely with UI/UX designs to build responsive, user-friendly interfaces.',
      'Implemented scalable frontend structures and connected client applications with backend APIs.'
    ]
  },
  {
    date: 'Jun 2022 — Aug 2022',
    title: 'Junior System Administrator',
    organization: 'Forte Bank · On-site · Astana, Kazakhstan',
    points: [
      'Configured and maintained Linux servers to support stable and secure operations.',
      'Set up and optimized Windows environments for 50+ workstations.',
      'Supported internal infrastructure and improved workstation readiness for employees.'
    ]
  },
  {
    date: 'Jun 2021 — Aug 2021',
    title: 'System Administrator',
    organization: 'TrendTech · On-site · Astana, Kazakhstan',
    points: [
      'Configured and secured network routers for the company’s internal infrastructure.',
      'Developed a layout plan for 40+ office workstations, improving cable management and equipment placement.',
      'Assisted with procurement and quality control for network devices to ensure compatibility and performance.'
    ]
  }
]